import { ScrollSpyContext } from "@/context/scroll-spy"
import * as React from "react"

export const SideMenuLink = ({ children, anchor }) => {
  const { activeScrollSpyElement } = React.useContext(ScrollSpyContext)

  return (
    <li>
      <a
        href={`#${anchor}`}
        data-active={activeScrollSpyElement === `#${anchor}` ? "true" : "false"}
        className="sidebar-menu__link"
      >
        {children}
      </a>
    </li>
  )
}

export const SideMenu = ({ children }) => {
  return <ul>{children}</ul>
}
